import React from "react";
import {Link} from "react-router-dom";
import {Objects, Types} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";

// noinspection JSUnresolvedVariable
/**
 * @param {Transactions_Entries_Object} entry
 * @param {Products_Object} product
 * @param {function} onDelete
 * @param {function} onUpdate
 * @param {function} openModal
 * @param {function} reportClose
 * @param {bool} modalUpdate
 * @param {object} history
 * @param {array} locations
 * @param {array} states
 * @param {function} updatePawn
 * @param locationManufacturer
 * @param {function} updateMagazine
 */
export default ({
									entry,
									product,
									onDelete,
									onUpdate,
									modalUpdate,
									openModal,
									reportClose,
									history,
									locations,
									states,
									updatePawn,
									locationManufacturer,
									updateMagazine
								}) => {
	entry.pawn_redemption = typeof entry.pawn_redemption === 'boolean' ? entry.pawn_redemption : false;
	entry.pawn_redemption_error = '';
	let teModel = API.BuildClass(Types.Transactions_Entries._name, API.RequestType.READ);
	return (
		<div key={product.pkey} className="portlet box blue-hoki">
			<div className="portlet-title">
				<div className="caption">
					<i className="fa fa-barcode"/>&nbsp;&nbsp;
					<Link to={"/products/" + product.binary_id + '-' + product.pkey}
					      style={{color: 'white'}}>{product.serial_number}</Link>
				</div>
				{onDelete && <div className="tools">
					<a href='#'
						 onClick={() => onDelete(entry.pkey || null, entry.binary_id || null, product.pkey, product.binary_id)}
						 className="remove"
						 style={{color: 'white'}}><i className={"fa fa-remove"}/></a>
				</div>}
			</div>
			<div className="portlet-body">
				{/*<Link to={"/products/" + product.pkey} className="btn btn-sm blue-hoki pull-right">View</Link>*/}
				<a onClick={openModal} className="btn btn-sm blue-hoki pull-right">View</a>
				<h5 style={{marginTop: 0}}>{product.type}</h5>
				<h5
					style={{margin: 0}}>{product.manufacturers && product.manufacturers.name + ' |'} {product.manufacturer_other && product.manufacturer_other + ' |'} {locationManufacturer && locationManufacturer + ' |'}  {product.model} | {product.calibers ? product.calibers.name : product.caliber_other}</h5>
				{updatePawn && <div style={{fontSize: '12px'}}>
					<hr/>
					<div className={'row'}>
						<div className={'col-6'}>
							<span className={'input-label'}>Pawned Redemption</span>
						</div>
						<div className={'col-6 text-right'}>
							<Framework.Elements.ButtonSwitch
								property={teModel.properties.pawn_redemption}
								value={entry.pawn_redemption}
								error={entry.pawn_redemption_error}
								update={updatePawn(entry)}
								labelTrue={'Yes'}
								labelFalse={'No'}
							/>
						</div>
					</div>
				</div>}
			</div>

			<UniversalModalOverride
				history={history}
				locations={locations}
				states={states}
				name={"Product"}
				id={product.pkey}
				binary_id={product.binary_id}
				object={Objects.ProductUpdate}
				objectProps={{
					object: product
				}}
				toggle={modalUpdate}
				reportClose={reportClose}
				afterSave={onUpdate}
				size={"xl"}
			/>
		</div>
	)
};
